module.exports = __webpack_public_path__ + "fonts/NanumSquareRoundL.e19ef53.eot";